import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})

export default class InsuranceRouteResolverService {

  public resolveInsuranceUrl(): string {
    return '/insurance';
  }

  public resolveAdvantagesUrl(): string {
    return '/insurance/advantages';
  }

  public resolveInsuranceFaqUrl(): string {
    return '/insurance/insurance-annual-costs';
  }
}
